import { BASE_URL } from "../../../config/apiConfig";
import { columnLabelMapper } from "../../../forms/incentiveClaimApplicationFields";
import { formatKeyNames } from "../../../utils/utils";

const TableView = ({ label, value, language = false }) => {
  const columns = Object.keys(value[0]);
  const isFilePath = (value) =>
    typeof value === "string" && value.startsWith("frontend/images/upload");

  return (
    <div key={label} className="col-span-full">
      <p className="font-semibold mb-2">{formatKeyNames(label)}</p>
      <div className="overflow-x-auto border rounded-md">
        <table className="w-full border-collapse text-sm">
          <thead className="bg-[#e5f5f4]">
            <tr>
              {columns.map((col) => (
                <th key={col} className="border px-3 py-2 text-left">
                  {(language
                    ? columnLabelMapper[col]?.hi
                    : columnLabelMapper[col]?.en) || formatKeyNames(col)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {value.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col) => {
                  const cellValue = row[col];

                  return (
                    <td key={col} className="border px-3 py-4">
                      {isFilePath(cellValue) ? (
                        <a
                          href={`${BASE_URL}/${cellValue}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-2 py-1 bg-btn text-white cursor-pointer rounded hover:opacity-90"
                        >
                          {language ? "फ़ाइल देखें" : "View File"}
                        </a>
                      ) : (
                        cellValue || "--"
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableView;
